import { render, staticRenderFns } from "./BuilderField.vue?vue&type=template&id=51f91cda&"
import script from "./BuilderField.vue?vue&type=script&lang=js&"
export * from "./BuilderField.vue?vue&type=script&lang=js&"
import style0 from "./BuilderField.vue?vue&type=style&index=0&id=51f91cda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports